var Migration, PremiumPresentationsUpdateText, mediator, migrationName, set, updateTemplateData,
  __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

mediator = require('mediator');

Migration = require('./migration');

set = require('lodash').set;

migrationName = 'premium_presentations_update_texts';

updateTemplateData = function(data) {
  set(data, ['presentations', 'sections', 'patients', 'sections', 'whatItMeansForYou', 'parts', 'speakWithHCProfessional', 'name'], "Talk with your health care professional");
  return data;
};

module.exports = PremiumPresentationsUpdateText = (function(_super) {
  __extends(PremiumPresentationsUpdateText, _super);

  function PremiumPresentationsUpdateText() {
    PremiumPresentationsUpdateText.__super__.constructor.call(this, false);
  }

  PremiumPresentationsUpdateText.prototype.up = function(project, colls) {
    var adapter, docIds, projectId;
    PremiumPresentationsUpdateText.__super__.up.apply(this, arguments);
    projectId = project.id;
    adapter = mediator.services.storePersistenceAdapter;
    docIds = colls.questions.reduce(function(docIds, q) {
      return docIds.concat(q.get('recommendationIds'));
    }, ['etd-tx-template', 'etd-dx-template']);
    return adapter.fetch(projectId, _.compact(_.uniq(docIds))).then(function(_arg) {
      var rows;
      rows = _arg.rows;
      return _.chain(rows).filter(function(rows) {
        return rows.doc != null;
      }).pluck('doc').value();
    }).then(function(templateDocs) {
      var updatedDocs;
      if (_.isEmpty(templateDocs)) {
        return;
      }
      updatedDocs = _.map(templateDocs, function(doc) {
        var _ref;
        if ((_ref = doc.templateDef.id) === 'good-practice-statement' || _ref === 'keyMessage') {
          return doc;
        }
        return _.extend(doc, {
          rev_author: "project_migration/" + migrationName,
          templateData: updateTemplateData(doc.templateData)
        });
      });
      return adapter.bulkDocs(projectId, updatedDocs);
    });
  };

  return PremiumPresentationsUpdateText;

})(Migration);
